module.exports = __webpack_public_path__ + "static/img/order.8915c146.png";